module.exports = __webpack_public_path__ + "img/funfacts4.b1fe1798.png";